import type { RequestParams, ScpClient } from '~shared/api/scp/client';

import type { ReportApi } from '..';
import type { CheckReportStatusResponse } from '../../model/check-report-status-response';

interface Params {
  scpClient: ScpClient;
  host: string;
}

export class GatewayReportApi implements ReportApi {
  host: string;
  client: ScpClient;

  constructor({ scpClient, host }: Params) {
    this.client = scpClient;
    this.host = host;
  }

  async checkReportStatus(
    reportId: string
  ): Promise<CheckReportStatusResponse> {
    return this.makeRequest<CheckReportStatusResponse>({
      method: 'check-report-status',
      payload: { reportId },
    }).then((response) => response.payload);
  }

  async downloadReport(reportId: string): Promise<ArrayBuffer> {
    return this.makeRequest<ArrayBuffer>({
      host: this.host,
      method: 'download-report',
      payload: { reportId },
      responseType: 'application/octet-stream',
      // 2 minutes
      timeout: 5 * 60 * 1000,
    });
  }

  private makeRequest<T = unknown>(
    params: Partial<RequestParams> & { method: string }
  ) {
    return this.client.call<T>({
      host: this.host,
      version: 'v1',
      domain: 'merchant-portal',
      service: 'public/dashboard',
      withCredentials: true,
      withLeadingDomain: true,
      ...params,
    });
  }
}
